import React, { useCallback, useState } from "react";
import ListHeader from "../../common/list/ListHeader";
import { useGetDocumentsQuery } from "../../../services/api/repositories/DocumentsRepository";
import ListActions from "../../common/list/ListActions";
import NavigationPagination from "../../common/NavigationPagination";
import TableDocuments from "./TableDocuments";
import { useNavigate} from "react-router-dom";

export default function DocumentsSection() {
    const navigate = useNavigate();

    const [currentPage, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);

    const {data, isLoading, isFetching} = useGetDocumentsQuery(
        {page: currentPage, per_page: perPage},
        {refetchOnMountOrArgChange: true}
    );

    const handleAction = useCallback(() => {
        navigate("/documents/new");
    }, [navigate]);


    return (
        <>
            <ListHeader 
                actions={
                    <ListActions
                        classAction='btn-add'
                        title="Ajouter une Pièce jointe"
                        textButton="Ajouter une Pièce jointe"
                        handleAction={ handleAction}
                    />
                }
                handleSubmit={() => console.log('Submit')}
                handleReset={() => console.log('Reset')}
            >
            </ListHeader>

            {(isLoading || isFetching) && <p>Chargement...</p>}
        
            {((!isLoading && !isFetching) && data !== undefined) && (
                <>
                    {("message" in data) && <p>{data.message}</p>}
                    {("total" in data) && 
                    (<>
                        <TableDocuments data={data} />
                        <NavigationPagination currentPage={currentPage} lastPage={data.last_page} setPage={setPage} perPage={perPage} setPerPage={setPerPage} />        
                    </>)}
                </>
                )
            }
            
            {((!isLoading && !isFetching) && data === undefined) && 
                <p>Une erreur a été rencontrée.</p>
            }
            
        </>
    );
}